export { default } from './PostFooter';
